import { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { API_URL } from '../config';

export const useQuizData = (collectionSlug) => {
  const [questions, setQuestions] = useState([]);
  const [loading,   setLoading  ] = useState(true);
  const [error,     setError    ] = useState(null);

  useEffect(() => {
    if (!collectionSlug) return;

    const source = axios.CancelToken.source();

    (async () => {
      setLoading(true);
      try {
        const query = qs.stringify({ populate: '*' }, { encodeValuesOnly: true });
        const url   = `${API_URL}/${collectionSlug}?${query}`;

        const { data } = await axios.get(url, { cancelToken: source.token });

        const pick     = (obj, key) => obj[key] ?? obj[key.toLowerCase()] ?? '';
        const pickBool = (obj, key) => !!(obj[key] ?? obj[key.toLowerCase()]);
        const pickNum  = (obj, key, def = 15) => {
          const raw = obj[key] ?? obj[key.toLowerCase()];
          const n   = Number(raw);
          return Number.isFinite(n) && n > 0 ? n : def;
        };

        const mapped = (data.data || []).map((rec) => {
          const a = rec.attributes ?? rec;                     
          return {
            id   : rec.id,
            text : pick(a, 'Frage'),

            answers: [
              { label: pick(a, 'Antwort1'), isCorrect: pickBool(a, 'Antwort1_richtig') },
              { label: pick(a, 'Antwort2'), isCorrect: pickBool(a, 'Antwort2_richtig') },
              { label: pick(a, 'Antwort3'), isCorrect: pickBool(a, 'Antwort3_richtig') },
            ],

            correctText     : pick(a, 'Text_Richtige_Antwort'),
            wrongText       : pick(a, 'Text_Falsche_Antwort'),
            feedbackDuration: pickNum(a, 'Feedback_Dauer'),    
          };
        });

        setQuestions(mapped);
        setError(null);
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error(`Error fetching ${collectionSlug}:`, err);
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    })();

    return () => source.cancel();
  }, [collectionSlug]);

  return { questions, loading, error };
};